import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (!this.supported || !this.fastEnough) return;

    this.element.addEventListener("playing", this.playing.bind(this));
    this.element.type = this.data.get("type");

    setTimeout(() => {
      this.element.src = this.data.get("src");
    }, 200);
  }

  disconnect() {
    this.element.removeEventListener("playing", this.playing.bind(this));
  }

  playing() {
    this.element.classList.remove("opacity-0");
  }

  get supported() {
    return navigator.userAgent.indexOf("Edge/") === -1 && "object-fit" in new Image().style;
  }

  get fastEnough() {
    return !navigator.connection || navigator.connection.downlink >= 1;
  }
}
